/* eslint react/no-multi-comp: 0 */
import React from 'react';

import { HeaderTabs } from '@ui/components';

const baseItems = [
    { key: 'overview', label: 'Overview' },
    { key: 'broadcasts', label: 'Broadcasts' },
    { key: 'social', label: 'Social' },
];

export const DefaultHeaderTabsExample = () => (
    <HeaderTabs items={baseItems} />
);

export const ActiveHeaderTabsExample = () => {
    const [activeKey, setActiveKey] = React.useState('broadcasts');

    return (
        <HeaderTabs
            activeKey={activeKey}
            items={baseItems}
            onChange={setActiveKey}
        />
    );
};

export const DisabledHeaderTabsExample = () => (
    <HeaderTabs
        defaultActiveKey="overview"
        items={[
            { key: 'overview', label: 'Overview' },
            { key: 'broadcasts', label: 'Broadcasts' },
            { key: 'reports', disabled: true, label: 'Reports' },
        ]}
    />
);

export const IconHeaderTabsExample = () => (
    <HeaderTabs
        defaultActiveKey="overview"
        items={[
            {
                icon: <span aria-hidden>📊</span>,
                key: 'overview',
                label: 'Overview',
            },
            {
                icon: <span aria-hidden>📺</span>,
                key: 'broadcasts',
                label: 'Broadcasts',
            },
        ]}
    />
);

export const LongLabelHeaderTabsExample = () => (
    <HeaderTabs
        defaultActiveKey="annual"
        items={[
            {
                key: 'annual',
                label: 'Annual sponsorship media value summary',
            },
            {
                key: 'quarterly',
                label: 'Quarterly broadcast exposure breakdown',
            },
        ]}
    />
);
